<style src="css/record.css" scoped></style>
<template>
  <div style="padding-top: 0.98rem">
    <div class="fixedBox">
      <div class="topBox">
        <div class="backIcon" @click="back()"></div>
        <!--                <div class="topTitle">{{chatDoctor.doctorName}}</div>-->
        <div class="topTitle">
          {{ typeStatus ? "咨询记录" : "填写咨询记录" }}
        </div>
        <div class="rule" @click="to(`recordDetails?bespeakId=${bespeakId}`)">
          更多
        </div>
      </div>
    </div>
    <div class="userInfoBox">
      <div class="modeTitle">咨询者信息</div>
      <div class="userInfo">
        <div class="userItem">
          <div class="userItemLeft">姓 名</div>
          <div class="userItemRight">{{ userName }}</div>
        </div>
        <div class="userItem">
          <div class="userItemLeft">手机号</div>
          <div class="userItemRight">{{ userPhone }}</div>
        </div>
        <div class="userItem">
          <div class="userItemLeft">问题类型</div>
          <div class="userItemRight">
            <span v-for="item in troubles">{{ item }}</span>
          </div>
        </div>
      </div>
      <div class="modeTitle">类型</div>
      <div class="interviewBox">
        <div class="inputBox">
          <div class="title">问题类型</div>

          <div class="selectBox">
            <div
              class="selectItem"
              v-for="item in wtList"
              @click="setProblemed(item)"
            >
              <div
                class="resultType"
                :class="{
                  active: item === problemed,
                }"
              ></div>
              {{ item }}
            </div>
          </div>
        </div>
        <div class="inputBox">
          <div class="title">疑似精神障碍类型</div>

          <div class="selectBox">
            <div
              class="selectItem"
              v-for="item in jsList"
              @click="setSuspected(item)"
            >
              <div
                class="resultType"
                :class="{
                  active: item === suspected,
                }"
              ></div>
              {{ item }}
            </div>
          </div>
        </div>
      </div>

      <div class="modeTitle">咨询记录</div>
      <div class="interviewBox">
        <div class="interviewTab">
          <div
            class="interviewItem"
            :class="{ actived: type === 0 }"
            @click="chanegType(0)"
          >
            初始访谈
          </div>
          <div class="interviewLine"></div>
          <div
            class="interviewItem"
            :class="{ actived: type === 1 }"
            @click="chanegType(1)"
          >
            后续访谈
          </div>
        </div>
        <div class="inputBox" v-if="type === 0">
          <div class="title">
            1.咨询师的第一印象(外表、行为、情绪、思维、反移情)；
          </div>
          <textarea
            :disabled="typeStatus"
            v-model="scaleUserBespeakDiscuss.impress"
          ></textarea>
          <div class="title">2.求助的原因对咨询的期望</div>
          <textarea
            :disabled="typeStatus"
            v-model="scaleUserBespeakDiscuss.causeExpect"
          ></textarea>
          <div class="title">3.近期的重大生活事件</div>
          <textarea
            :disabled="typeStatus"
            v-model="scaleUserBespeakDiscuss.recentEvent"
          ></textarea>
          <div class="title">4.近期的原因及对咨询的期望</div>
          <textarea
            :disabled="typeStatus"
            v-model="scaleUserBespeakDiscuss.recentExpect"
          ></textarea>
          <div class="title">5.家庭环境、与家人的关系</div>
          <textarea
            :disabled="typeStatus"
            v-model="scaleUserBespeakDiscuss.familyRelation"
          ></textarea>
          <div class="title">6.人际关系、亲密关系</div>
          <textarea
            :disabled="typeStatus"
            v-model="scaleUserBespeakDiscuss.mateRelation"
          ></textarea>
          <div class="title">7.问题分析与处理情况</div>
          <textarea
            :disabled="typeStatus"
            v-model="scaleUserBespeakDiscuss.quesTreat"
          ></textarea>
          <div class="title">8.自杀意念史</div>
          <div class="selectBox">
            <div class="selectItem" v-for="(item,index) in selectList" @click="item.ynStatus=!item.ynStatus" :key="index">
              <div class="resultType"
                :class="{
                  active: item.ynStatus,
                }"
              ></div>
              {{ item.name }}
            </div>
          </div>
          <div class="title">9.自杀计划史</div>
          <div class="selectBox">
            <div class="selectItem" v-for="(item,index) in selectList" @click="item.jhStatus=!item.jhStatus" :key="index">
              <div class="resultType"
                :class="{
                  active: item.jhStatus,
                }"
              ></div>
              {{ item.name }}
            </div>
          </div>
          <div class="title">10.自杀行为史</div>
          <div class="selectBox">
            <div class="selectItem" v-for="(item,index) in selectList" @click="item.xwStatus=!item.xwStatus" :key="index">
              <div class="resultType"
                :class="{
                  active: item.xwStatus,
                }"
              ></div>
              {{ item.name }}
            </div>
          </div>
          <div class="btn" @click="doctorDoBespeakDiscuss" v-if="!typeStatus">
            提交
          </div>
        </div>
        <div class="inputBox" v-if="type === 1">
          <div class="title">
            咨询时间：<span>{{ bespeakDate | time }}</span>
          </div>
          <div class="title">1.讨论议题，需特别关注之处：</div>
          <textarea
            :disabled="typeStatus"
            v-model="scaleUserBespeakNote.focus"
          ></textarea>
          <div class="title">2.本次咨询目标：</div>
          <textarea
            :disabled="typeStatus"
            v-model="scaleUserBespeakNote.target"
          ></textarea>
          <div class="title">3.问题分析:</div>
          <textarea
            :disabled="typeStatus"
            v-model="scaleUserBespeakNote.description"
          ></textarea>
          <div class="title">4.处理结果</div>

          <div class="selectBox">
            <div
              class="selectItem"
              v-for="item in resultTypeList"
              @click="selectResultType(item.resultType, item.name)"
            >
              <div
                class="resultType"
                :class="{
                  active: item.resultType === scaleUserBespeakNote.resultType,
                }"
              ></div>
              {{ item.name }}
            </div>
          </div>
          <input
            type="text"
            v-if="scaleUserBespeakNote.resultType == 4"
            :disabled="typeStatus"
            v-model="scaleUserBespeakNote.remark"
          />
          <div class="title">5.后续安排（建议下一次咨询时间）</div>
          <input
            type="text"
            :disabled="typeStatus"
            v-model="scaleUserBespeakNote.followUp"
            @click="isShowCalendar = true"
          />
          <div class="btn" @click="doctorDoBespeakNote" v-if="!typeStatus">
            提交
          </div>
        </div>
      </div>
    </div>
    <vue-hash-calendar
      format="YY-MM-DD"
      :showTodayButton="false"
      @confirm="confirm"
      :disabled-date="disabledDate"
      pickerType="date"
      model="dialog"
      :visible.sync="isShowCalendar"
      style=""
    ></vue-hash-calendar>
    <div class="tipBox" v-if="tipStatus">
      <div class="tip">{{ tip }}</div>
    </div>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import topbar from "components/topbar";
import moment from "moment/moment";

import { serialize } from "utils/index";

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,

      isShowCalendar: false,
      tipStatus: false,
      tip: "",
      type: 0,
      typeStatus: false,
      bespeakId: "",
      userName: "",
      userPhone: "",
      troubles: "",
      bespeakDate: "",
      scaleUserBespeakDiscuss: {
        discussId: "",
        bespeakId: "",
        userId: "",
        doctorId: "",
        impress: "",
        causeExpect: "",
        recentEvent: "",
        recentExpect: "",
        familyRelation: "",
        mateRelation: "",
        quesTreat: "",
        killYns:"",
        killJhs:"",
        killXws:"",
      },
      scaleUserBespeakNote: {
        noteId: "",
        bespeakId: "",
        userId: "",
        doctorId: "",
        focus: "",
        target: "",
        description: "",
        result: "",
        resultType: "",
        followUp: "",
        remark: "",
      },
      problemed:'',
      suspected:'',
      wtList: [
        "自我探索",
        "人际关系",
        "学业问题",
        "恋爱情感",
        "亲子家庭",
        "生涯发展",
        "情绪困扰",
        "性别认同",
        "适应问题",
        "强迫行为",
        "突发危机",
        "身心健康",
        "其他",
      ],
      selectList:[
        {
          name: "无",
          resultType: 0,
          ynStatus:false,
          jhStatus:false,
          xwStatus:false,
        },
        {
          name: "小学有过",
          resultType: 1,
          ynStatus:false,
          jhStatus:false,
          xwStatus:false,
        },
        {
          name: "初中有过",
          resultType: 2,
          ynStatus:false,
          jhStatus:false,
          xwStatus:false,
        },
        {
          name: "高中有过",
          resultType: 3,
          ynStatus:false,
          jhStatus:false,
          xwStatus:false,
        },
        {
          name: "大学有过",
          resultType: 4,
          ynStatus:false,
          jhStatus:false,
          xwStatus:false,
        },
      ],
      jsList: [
        "精神分裂症",
        "双相情感障碍",
        "抑郁症",
        "焦虑症",
        "强迫症",
        "睡眠障碍",
        "进食障碍",
        "成瘾障碍",
        "创伤及应激障碍",
        "人格障碍",
        "其他精神症状",
        "无",
      ],
      resultTypeList: [
        {
          name: "继续咨询",
          resultType: 0,
        },
        {
          name: "建议就医",
          resultType: 1,
        },
        {
          name: "反馈院系",
          resultType: 2,
        },
        {
          name: "危机干预",
          resultType: 3,
        },
        {
          name: "其他",
          resultType: 4,
        },
      ],
    };
  },
  components: {
    noMoreData,
    topbar,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    setProblemed(item){
      this.problemed = item;
      this.saveBespeakRecord()
    },
    setSuspected(item){
      this.suspected = item;
      this.saveBespeakRecord()
    },

    async saveBespeakRecord() {
      let obj = {};
      obj.bespeakId = this.bespeakId;
      obj.problemed = this.problemed;
      obj.suspected = this.suspected;
      let data = await getSources(
        "/bear-scale/api/scaleUserBespeak/saveBespeakRecord",
        obj
      );
      if (data.status === 0) {

      } else {
        this.showTip(data.msg);
      }
    },
    to(n) {
      this.$router.push(`/${n}`);
    },
    back() {
      history.back();
    },
    disabledDate(date) {
      let timestamp = date.getTime();
      if (timestamp <= new Date().getTime()) {
        return true;
      }

      return false;
    },
    confirm(date) {
      this.scaleUserBespeakNote.followUp = date;
    },
    showTip(v) {
      this.tip = v;
      this.tipStatus = true;
      setTimeout(() => {
        this.tipStatus = false;
      }, 1500);
    },
    selectResultType(n, name) {
      if (this.typeStatus) {
      } else {
        this.scaleUserBespeakNote.resultType = n;
        this.scaleUserBespeakNote.result = name;
      }
    },
    setKeyValue(n, name, k) {
      if (k===1) {
          this.scaleUserBespeakDiscuss.killYns = n
      } else if(k===2){

          this.scaleUserBespeakDiscuss.killJhs = n
      } else if(k===3){

          this.scaleUserBespeakDiscuss.killXws = n
      }
    },

    chanegType(n) {
      this.type = n;
      this.getUserBespeakNoteOrDiscuss();
    },
    async getUserBespeakNoteOrDiscuss() {
      console.log(1);
      let obj = {};
      obj.bespeakId = this.bespeakId;
      obj.type = this.type;
      let data = await getSources(
        "/bear-scale/api/scaleUserBespeak/getUserBespeakNoteOrDiscuss.json",
        obj
      );
      if (data.status === 0) {
        if (data.scaleUserBespeakDiscuss) {
          this.scaleUserBespeakDiscuss = data.scaleUserBespeakDiscuss;
          let arr1 = []
          arr1=this.scaleUserBespeakDiscuss.killYns&&this.scaleUserBespeakDiscuss.killYns.split(',')
          let arr2 = []
          arr2=this.scaleUserBespeakDiscuss.killJhs&&this.scaleUserBespeakDiscuss.killJhs.split(',')
          let arr3 = []
          arr3=this.scaleUserBespeakDiscuss.killXws&&this.scaleUserBespeakDiscuss.killXws.split(',')

          this.selectList.forEach(va=>{
            arr1.forEach(v=>{
              v==va.resultType&&(va.ynStatus=true)
            })
            arr2.forEach(v=>{
              v==va.resultType&&(va.jhStatus=true)
            })
            arr3.forEach(v=>{
              v==va.resultType&&(va.xwStatus=true)
            })
          })
        }
        if (data.scaleUserBespeakNote) {
          this.scaleUserBespeakNote = data.scaleUserBespeakNote;
        }
        this.userName = data.userName;
        this.userPhone = data.userPhone;
        this.bespeakDate = data.bespeakDate;
        this.problemed = data.problemed;
        this.suspected = data.suspected;
        this.troubles = JSON.parse(data.troubles);
      } else {
        this.showTip(data.msg);
      }
    },
    async doctorDoBespeakDiscuss() {
      let obj = {};
      obj.discussId = this.scaleUserBespeakDiscuss.discussId;
      obj.bespeakId = this.bespeakId;
      obj.userId = this.scaleUserBespeakDiscuss.userId;
      obj.doctorId = this.scaleUserBespeakDiscuss.doctorId;
      obj.impress = this.scaleUserBespeakDiscuss.impress;
      obj.causeExpect = this.scaleUserBespeakDiscuss.causeExpect;
      obj.recentEvent = this.scaleUserBespeakDiscuss.recentEvent;
      obj.recentExpect = this.scaleUserBespeakDiscuss.recentExpect;
      obj.familyRelation = this.scaleUserBespeakDiscuss.familyRelation;
      obj.mateRelation = this.scaleUserBespeakDiscuss.mateRelation;
      obj.quesTreat = this.scaleUserBespeakDiscuss.quesTreat;
      obj.killYns='';
      obj.killJhs='';
      obj.killXws='';
      this.selectList.forEach(v=>{
        v.ynStatus&&(obj.killYns+=v.resultType+',')
        v.jhStatus&&(obj.killJhs+=v.resultType+',')
        v.xwStatus&&(obj.killXws+=v.resultType+',')
      })
      obj.killYns=obj.killYns.slice(0,obj.killYns.length-1)
      obj.killJhs=obj.killJhs.slice(0,obj.killJhs.length-1)
      obj.killXws=obj.killXws.slice(0,obj.killXws.length-1)
      let data = await getSources(
        "/bear-scale/api/scaleUserBespeak/doctorDoBespeakDiscuss.json",
        obj
      );
      if (data.status === 0) {
        this.showTip("提交成功");
        this.getUserBespeakNoteOrDiscuss();
      } else {
        this.showTip(data.msg);
      }
    },
    async doctorDoBespeakNote() {
      let obj = {};
      obj.noteId = this.scaleUserBespeakNote.noteId;
      obj.bespeakId = this.bespeakId;
      obj.userId = this.scaleUserBespeakNote.userId;
      obj.doctorId = this.scaleUserBespeakNote.doctorId;
      obj.focus = this.scaleUserBespeakNote.focus;
      obj.target = this.scaleUserBespeakNote.target;
      obj.description = this.scaleUserBespeakNote.description;
      obj.result = this.scaleUserBespeakNote.result;
      obj.resultType = this.scaleUserBespeakNote.resultType;
      obj.followUp = this.scaleUserBespeakNote.followUp;
      obj.remark = this.scaleUserBespeakNote.remark;
      let data = await getSources(
        "/bear-scale/api/scaleUserBespeak/doctorDoBespeakNote.json",
        obj
      );
      if (data.status === 0) {
        this.showTip("提交成功");
        this.getUserBespeakNoteOrDiscuss();
      } else {
        this.showTip(data.msg);
      }
    },
  },
  destroyed() {},
  mounted() {
    if (this.$route.query.typeStatus == 1) {
      this.typeStatus = true;
    }
    this.bespeakId = this.$route.query.bespeakId;
    this.getUserBespeakNoteOrDiscuss();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/record.vue